import { RealTimeEventTypes } from '@/enums/RealTimeEventTypes'
import type { ICommandStatus } from '@/models/Diagnostics/ICommandStatus'
import { injectable } from 'inversify'
import { RealTimeEventService, type EventHandler, type IRealtimeEventService } from './RealTimeEventService'

export interface ICommandRealTimeEventService extends IRealtimeEventService {}

@injectable()
export class CommandRealTimeEventService extends RealTimeEventService implements ICommandRealTimeEventService {
  constructor(hub: string = 'command') {
    super(hub)
  }

  buildConnection(): void {
    super.buildConnection()
    this.connection.on('CommandUpdateEventAsync', this.onCommandUpdateEventAsync.bind(this))
  }

  async onCommandUpdateEventAsync(commandUpdate: ICommandStatus): Promise<void> {
    this.eventHandlers
      .filter(eh => eh.eventType === RealTimeEventTypes.CommandUpdateEvent)
      .forEach(async (eventHandler: EventHandler<ICommandStatus>) => {
        await eventHandler.handle(commandUpdate)
      })
  }
}
